export default __webpack_public_path__ + "static/media/child.7111b484.png";